// @ts-check

import * as Sentry from '@sentry/vue'

export const init = (app) =>
  Sentry.init({
    app,
    release: process.env.VUE_APP_RELEASE_HASH,
    dsn: process.env.VUE_APP_SENTRY_DSN || '',
    environment: process.env.VUE_APP_SENTRY_ENV || 'development',
    attachProps: true,
    allowUrls: [
      'localhost',
      '127.0.0.1',
      'ukkopro.fi',
      'osakeyhtio.ukko.fi',
      'kevytyritys.ukko.fi',
      'ukko.dev'
    ],
    normalizeDepth: 0,
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true
      }),
      Sentry.replayIntegration({
        networkDetailAllowUrls: [
          /actions/i,
          /attachments/i,
          /bank-transactions/i,
          /dashboard/i,
          /document-periods/i,
          /expenses/i,
          /incomes/i,
          /invoices/i,
          /journals/i,
          /reports/i,
          /subscriptions/i,
          /swan/i,
          /tax-returns/i,
          /customers/i
        ],
        networkCaptureBodies: true
      }),
      Sentry.captureConsoleIntegration()
    ],
    ignoreErrors: [/Network Error/i, /Request aborted/i]
  })

/**
 * Reports given message with additional data to Sentry.
 * @param {string} message
 * @param {any} extra
 */
export const report = (message, extra = undefined) =>
  Sentry.captureException(new Error(message), { extra })
